module.exports = __webpack_public_path__ + "static/media/home-image.dc2101c9.svg";